(function () {
  function initOptionsATC(picker) {
    var blockId = picker.id.replace('options-atc-picker-', '');
    var drawer  = document.getElementById('options-atc-drawer-' + blockId);
    if (!drawer) return;

    var displayStyle    = picker.dataset.displayStyle || 'image';
    var isMobile        = function () { return window.matchMedia('(max-width: 999px)').matches; };
    var headerLabel     = picker.querySelector('.options-atc__selected-label');
    var drawerThumbs    = drawer.querySelector('.options-atc__drawer-thumbs');
    var drawerImgWrap   = drawer.querySelector('.options-atc__drawer-img-wrap');
    var drawerImg       = drawer.querySelector('.options-atc__drawer-img');
    var drawerItemTitle = drawer.querySelector('.options-atc__drawer-item-title');
    var drawerItemDesc  = drawer.querySelector('.options-atc__drawer-item-desc');
    var drawerSelectBtn = drawer.querySelector('.options-atc__drawer-select');
    var items           = Array.from(picker.querySelectorAll('label.options-atc__item'));
    var pendingInputId  = null;

    // Desktop: sync header label with selected radio
    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (headerLabel) headerLabel.textContent = this.value;
      });
    });

    // Build drawer thumbnail buttons respecting display_style
    items.forEach(function (item) {
      var forId = item.getAttribute('for');
      var title = item.dataset.atcTitle;
      var thumb = item.dataset.atcThumb;
      var btn   = document.createElement('button');
      btn.type  = 'button';
      btn.className = 'options-atc__drawer-thumb-btn';
      btn.dataset.forInput = forId;

      if (displayStyle === 'image' && thumb) {
        var img     = document.createElement('img');
        img.src     = thumb;
        img.alt     = title;
        img.loading = 'lazy';
        btn.appendChild(img);
      } else {
        btn.classList.add('options-atc__drawer-thumb-btn--text');
        btn.textContent = title;
      }

      btn.addEventListener('click', function () {
        showInDrawer(this.dataset.forInput);
      });
      drawerThumbs.appendChild(btn);
    });

    function showInDrawer(inputId) {
      pendingInputId = inputId;
      var label  = picker.querySelector('[for="' + inputId + '"]');
      if (!label) return;

      var imgSrc = label.dataset.atcImage;
      var title  = label.dataset.atcTitle;
      var desc   = label.dataset.atcDesc;

      if (imgSrc) {
        drawerImg.src     = imgSrc;
        drawerImg.alt     = title;
        drawerImgWrap.hidden = false;
      } else {
        drawerImgWrap.hidden = true;
      }

      drawerItemTitle.textContent = title;
      drawerItemDesc.textContent  = desc || '';
      drawerItemDesc.hidden       = !desc;

      drawerThumbs.querySelectorAll('.options-atc__drawer-thumb-btn').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.forInput === inputId);
      });
    }

    function openDrawer(inputId) {
      showInDrawer(inputId);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Mobile: tap the ? icon to open drawer for the currently selected item
    var infoBtn = picker.querySelector('.options-atc__info-btn');
    if (infoBtn) {
      infoBtn.addEventListener('click', function () {
        if (!isMobile()) return;
        var checked = picker.querySelector('input[type="radio"]:checked');
        var targetId = checked ? checked.id : (items[0] ? items[0].getAttribute('for') : null);
        if (targetId) openDrawer(targetId);
      });
    }

    // Confirm button: check the radio and close
    drawerSelectBtn.addEventListener('click', function () {
      if (pendingInputId) {
        var input = document.getElementById(pendingInputId);
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      closeDrawer();
    });

    drawer.querySelector('.options-atc__drawer-backdrop').addEventListener('click', closeDrawer);
    drawer.querySelector('.options-atc__drawer-close').addEventListener('click', closeDrawer);

    // Desktop: hover-positioned popup (popup container lives outside product-info)
    var popupGap = 20;
    var activePopup = null;

    function hideActivePopup() {
      if (!activePopup) return;
      activePopup.classList.remove('is-visible');
      activePopup.setAttribute('aria-hidden', 'true');
      activePopup = null;
    }

    function positionPopup(label, popup) {
      // Make measurable without flashing
      popup.style.visibility = 'hidden';
      popup.classList.add('is-visible');

      var labelRect = label.getBoundingClientRect();
      var popupWidth = popup.offsetWidth;
      var popupHeight = popup.offsetHeight;
      var margin = 8;

      var placement = 'left';
      var left = labelRect.left - popupWidth - popupGap;
      if (left < margin) {
        placement = 'right';
        left = labelRect.right + popupGap;
      }
      left = Math.max(margin, Math.min(left, window.innerWidth - popupWidth - margin));

      var top = labelRect.top + labelRect.height / 2 - popupHeight / 2;
      top = Math.max(margin, Math.min(top, window.innerHeight - popupHeight - margin));

      popup.dataset.placement = placement;
      popup.style.left = left + 'px';
      popup.style.top = top + 'px';
      popup.style.visibility = '';
    }

    function showPopupFor(label) {
      if (isMobile()) return;
      var popupId = label.dataset.popupId;
      if (!popupId) return;
      var popup = document.querySelector('[data-popup-for="' + popupId + '"]');
      if (!popup) return;
      if (activePopup && activePopup !== popup) hideActivePopup();
      activePopup = popup;
      positionPopup(label, popup);
      popup.setAttribute('aria-hidden', 'false');
    }

    items.forEach(function (label) {
      label.addEventListener('mouseenter', function () { showPopupFor(label); });
      label.addEventListener('mouseleave', hideActivePopup);
      label.addEventListener('focus', function () { showPopupFor(label); });
      label.addEventListener('blur', hideActivePopup);
    });

    window.addEventListener('scroll', hideActivePopup, true);
    window.addEventListener('resize', hideActivePopup);
  }

  function init() {
    document.querySelectorAll('.options-atc__component').forEach(initOptionsATC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
